import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getUserDetail, isLoggedIn } from "../utils/helper";
import { useDispatch } from "react-redux";
import { ERROR } from "../constants/types/alertType";
const PrivateRoute = ({ component: Component, path: path, ...rest }) => {
  let isAllowed = getUserDetail()?.practitioner_status == 1;
  let isSemiAllowed = getUserDetail()?.practitioner_status == 0;
  let mainRole = getUserDetail()?.mainRole;
  let isSubscribed = getUserDetail()?.subscription;
  const dispatch = useDispatch();
  if (
    path.includes("/prescriptions") ||
    path.includes("/prescription") ||
    path.includes("/patients") ||
    ((!isSemiAllowed || !isSubscribed) && path.includes("/formulas"))
  ) {
    if (mainRole.val !== 3 && !isAllowed) {
      dispatch({
        type: ERROR,
        payload:
          "You can only use this feature after receiving verification from an admin.",
      });
      return (
        <Route
          {...rest}
          render={(props) =>
            isLoggedIn() ? <Redirect to="/app" /> : <Redirect to="/login" />
          }
        />
      );
    }

    if (mainRole.val !== 3 && !isSubscribed) {
      return (
        <Route
          {...rest}
          render={(props) =>
            isLoggedIn() ? (
              <Redirect to="/app/subscription" />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
      );
    } else {
      return (
        <Route
          {...rest}
          render={(props) =>
            isLoggedIn() ? <Component {...props} /> : <Redirect to="/login" />
          }
        />
      );
    }
  } else {
    return (
      <Route
        {...rest}
        render={(props) =>
          isLoggedIn() ? <Component {...props} /> : <Redirect to="/login" />
        }
      />
    );
  }
};

export default PrivateRoute;
